<div (window:scroll)="onScroll($event)">
<div (click)="scrollTop()" *ngIf="showHome" class="jumper btn btn-link">Back to Top</div>

<div class="big-box">

  <div class="ui-g ui-fluid sticky" >
    <div class="col-2 ui-g-2">
      <h1><a class="tab-link tab-active" routerLink="/servicedesk">Accounts</a></h1>
    </div>
    <div class="col-2 ui-g-2">
      <h1><a class="tab-link" routerLink="{{isAccountSelected ? '/usermanagement/'+selectedAccount.accountId : '/usermanagement'}}">Users</a></h1>
    </div>
  </div>

  <div class="center">
      <iui-messages mode="alert" class="ms-auto me-auto"></iui-messages>
  </div>

  <!--regional-user-agreement #rua [ruaList]="selectedAccountCopy.ruaList" (ruaListChange)="saveRuaList($event)"></regional-user-agreement-->

  <!-- edit account ------------------------------------------------------- -->
  <div *ngIf="editHandle?.showArea">

    <div class="ui-g result-bar">
      <div id="edit-account">Edit Account</div>
      <div class="ui-g-x">
        <button id="btn-edit-account-save"  [disabled]="!isAccountFormValid(selectedAccountCopy)" [class]="'w-auto btn ' + (!isAccountFormValid ? 'btn-disabled' : 'btn-default')"
          (click)="saveEditAccount(selectedAccountCopy)">
          Save
        </button>
      </div>
      <button id="btn-edit-account-cancel" class="btn btn-secondary w-auto" (click)="cancelEditAccount()">Cancel</button>
    </div>

    <form ngForm #sdForm="ngForm" name="sdForm" id="sdFormid">
      <div class="ui-g">

          <div class="ui-g-1">
            <div class="mb-3">
              <label class="disabled form-label" for="accountId">Account ID</label>
              <input type="text" class="form-control" id="accountId" disabled [(ngModel)]="selectedAccountCopy.accountId" name="accountId"
                placeholder="Account ID" #accountId="ngModel">
            </div>
          </div>

          <div class="ui-g-2">
            <div class="mb-3">
              <label class="required form-label" for="companyName">Company Name</label>
              <input autocomplete='organization' type="text" class="form-control" id="companyName" required [(ngModel)]="selectedAccountCopy.companyName" name="companyName"
                #companyName="ngModel">
            </div>
          </div>

          <div class="ui-g-3">
            <div class="mb-3">
              <label class="disabled form-label" for="status">Status</label>
              <input type="text" class="form-control" id="status" disabled [(ngModel)]="selectedAccountCopy.status" name="status" placeholder="Status"
                #status="ngModel">
            </div>
          </div>

          <!--div class="ui-g-3">
            <div class="mb-3">
              <div><label>Regional User Agreement</label></div>
              <div (click)="showRuaDialog()" class="btn btn-link rua-button">{{getRuaDisplay()}}</div>
            </div>
          </div-->

          <div class="ui-g-2">
            <div class="mb-3 required">
              <label class="required leveltext form-label" for="accountType">Account Type</label>
              <div class="input-group">
                <p-dropdown [(ngModel)]="selectedAccountCopy.accountType"  [filter]="false" [inputId]="'accountType'" [options]="accountTypes"
                  placeholder="Select" [required]="true" [style]="{'width': '100%'}" #accountType class="p-formcontrol"
                  id="accountType" [name]="'accountType'" [disabled]="selectedAccountCopy.status=='inactive'"></p-dropdown>
              </div>
            </div>
          </div>
          <div class="ui-g-2">
              <div class="mb-3 required">
                <label class="required leveltext form-label" for="contractType">Contract Type</label>
                <div class="input-group">
                  <p-dropdown [(ngModel)]="selectedAccountCopy.contractType"  [filter]="false" [inputId]="'contractType'" [options]="contractTypes"
                    placeholder="Select" [required]="true" [style]="{'width': '100%'}" #accountType class="p-formcontrol"
                    id="contractType" [name]="'contractType'" [disabled]="selectedAccountCopy.status!='pending' && selectedAccountCopy.status!='rejected'"></p-dropdown>
                </div>
              </div>
            </div>

            <div class="ui-g-2">
                <div><label>&nbsp;</label></div>
                <div>
                    <p-checkbox [(ngModel)]="selectedAccountCopy.reportAccess" name="reportAccess" binary="true"></p-checkbox>
                    <label for="reportAccess">Report Access</label>
                </div>
            </div>
        
      </div>
      <div class="ui-g">
          <div class="ui-g-1">
              <div class="mb-3">
                <label class="form-label" for="spid">SPID</label>
                <input type="text" class="form-control" id="spid" [(ngModel)]="selectedAccountCopy.spid" name="spid" placeholder="xxxx"
                  #spid="ngModel">
              </div>
            </div>
        <div class="ui-g-1" style= "margin-right: 2.5em">
          <div class="mb-3">
            <label [ngClass]="{'required':selectedAccountCopy?.status == 'active'}" for="maxActiveApiSessions" class="leveltext form-label">Max API Sessions</label>
            <input [required]="selectedAccountCopy?.status == 'active'" autocomplete='max-active-api-sessions' type="text" class="form-control" id="maxActiveApiSessions"
                   [pattern]="numberValidatorPattern()" [(ngModel)]="selectedAccountCopy.maxActiveApiSessions"
                   name="maxActiveApiSessions" #maxActiveApiSessions="ngModel">
          </div>
        </div>
        <div class="ui-g-2">
          <div class="mb-3">
            <label class="form-label" for="purchaseOrderNumber">Purchase Order Number</label>
            <input autocomplete='purchaseOrderNumber' type="text" class="form-control" id="purchaseOrderNumber"
                   [(ngModel)]="selectedAccountCopy.purchaseOrderNumber" name="purchaseOrderNumber"
                   #purchaseOrderNumber="ngModel">
          </div>
        </div>

        <div class="ui-g-2">
          <div class="mb-3">
            <label class="form-label" for="nsContract">NetSuite Contract</label>
            <input autocomplete='nsContract' type="text" class="form-control" id="nsContract" appAlphaNumOnly
              [ngModel]="selectedAccountCopy.nsContract" (ngModelChange)="selectedAccountCopy.nsContract = $event.toUpperCase()" 
              name="nsContract" #nsContract="ngModel" minlength="6" maxlength="6">
          </div>
        </div>
        <div class="ui-g-2">
          <div class="mb-3">
            <label class="form-label" for="nsProject">NetSuite Project</label>
            <input autocomplete='nsProject' type="text" class="form-control" id="nsProject" appAlphaNumOnly
                  [ngModel]="selectedAccountCopy.nsProject" (ngModelChange)="selectedAccountCopy.nsProject = $event.toUpperCase()"
                  name="nsProject" #nsProject="ngModel" minlength="6" maxlength="6">
          </div>
        </div>
      </div>

      <div *ngIf="selectedAccountCopy?.accountType == 'standard' || selectedAccountCopy?.accountType == 'nonStandard'">
          <label [ngClass]="{'required':(selectedAccountCopy?.status == 'active' && selectedAccountCopy?.accountType == 'standard') || selectedAccountCopy?.accountType == 'nonStandard'}">
            <strong>Monthly Fee Schedule</strong>
          </label>
        </div>
        <div class="ui-g" >
          <div class="ui-g-6">
            <fee-schedule *ngIf="selectedAccountCopy.accountType === ACCOUNT_TYPE_STANDARD" (selectedTierChange)="updateTierChange($event)"
              [(selectedTier)]="selectedAccountCopy.tier" [disabled]="selectedAccountCopy.status!='active'"></fee-schedule>
          </div>
        </div>
        <div class="ui-g">
          <div class="ui-g-6">
            <custom-fee-schedule *ngIf="selectedAccountCopy.accountType === ACCOUNT_TYPE_NON_STANDARD" [customTier]="selectedAccountCopy.custom" (customTierChange)="onCustomTierChange($event)"></custom-fee-schedule>
          </div>
        </div>
  
      <div>
        <strong>Account Contact Information</strong>
      </div>
      <div class="ui-g">

        <div class="ui-g-2">

          <div class="mb-3">
            <label class="required form-label" for="firstName">First Name</label>
            <input autocomplete='given-name' type="text" class="form-control" id="firstName" required [pattern]="nameValidatorPattern()" [(ngModel)]="selectedAccountCopy.firstName"
              name="firstName" #firstName="ngModel">
          </div>

          <div class="mb-3">
            <label class="required form-label" for="lastName">Last Name</label>
            <input autocomplete='family-name' type="text" class="form-control" id="lastName" required [pattern]="nameValidatorPattern()" [(ngModel)]="selectedAccountCopy.lastName"
              name="lastName" #lastName="ngModel">
          </div>

        </div>

        <div class="ui-g-2">

          <div class="mb-3">
            <label class="required form-label" for="email">Email Address</label>
            <input autocomplete='email' type="text" class="form-control" id="email" required emailvalidator [(ngModel)]="selectedAccountCopy.email"
              name="email" placeholder="email@domain.com" #email="ngModel">
          </div>

          <div class="mb-3">
            <label class="form-label" for="phone">Telephone Number</label>
            <input autocomplete='tel-national' type="text" class="form-control" id="phone" minlength="7" [(ngModel)]="selectedAccountCopy.phone"
              name="phone" #phone="ngModel">
          </div>

        </div>

        <div class="ui-g-2">

          <div class="mb-3">
            <label class="form-label" for="country">Country</label>
            <div class="input-group">
              <p-dropdown autocomplete='country-name' #country id="country" placeholder="Select"  [filter]="true" [style]="{'width': '100%'}"
                class="p-formcontrol" [(ngModel)]="selectedAccountCopy.country" iuiCountry [region]="state" [name]="'country'"></p-dropdown>
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label" for="address1">Address 1</label>
            <input autocomplete='address-line1' type="text" class="form-control" id="address1" [pattern]="nameValidatorPattern()" [(ngModel)]="selectedAccountCopy.address1"
              name="address1" placeholder="street address" #address1="ngModel">
          </div>

        </div>

        <div class="ui-g-2">

          <div class="mb-3">
            <label class="form-label" for="address2">Address 2</label>
            <input autocomplete='address-line2' type="text" class="form-control" id="address2" [pattern]="nameValidatorPattern()" [(ngModel)]="selectedAccountCopy.address2"
              name="address2" placeholder="suite, floor, etc." #address2="ngModel">
          </div>

          <div class="mb-3">
            <label class="form-label" for="city">City</label>
            <input autocomplete='address-level2' type="text" class="form-control" id="city" [pattern]="nameValidatorPattern()" [(ngModel)]="selectedAccountCopy.city" name="city"
              #city="ngModel">
          </div>

        </div>

        <div class="ui-g-2">

          <div class="mb-3">
            <label class="form-label" for="state">State/ Province</label>
            <div class="input-group">
              <p-dropdown autocomplete='address-level1' [disabled]="!selectedAccountCopy.country" [(ngModel)]="selectedAccountCopy.state"  [filter]="true" [inputId]="'state'"
                placeholder="Select" [style]="{'width': '100%'}" #state class="p-formcontrol" id="state" iuiRegion [name]="'state'"></p-dropdown>
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label" for="zipCode">Postal/ ZIP Code</label>
            <input autocomplete='postal-code' type="text" class="form-control" id="zipCode" [(ngModel)]="selectedAccountCopy.zipCode" name="zipCode"
            [pattern]="zipCodeValidatorPattern(selectedAccountCopy?.billingCountry)" #zipCode="ngModel">
          </div>
        </div>

      </div>

      <div style= "margin-bottom: .5em;">
        <strong>Billing Contact Information</strong>
      </div>
      <div class="ui-g">
        <p-checkbox [(ngModel)]="sameAsAccount" name="sameAsAccount" binary="true" (onChange)="sameAsAccountInfo($event)"></p-checkbox><label for="sameAsAccount">Same as Account Contact Information</label>
      </div>
      <div class="ui-g">

        <div class="ui-g-2">

          <div class="mb-3">
            <label [ngClass]="{'required':selectedAccountCopy?.status == 'active'}" class="form-label" for="billingFirstName">Billing First Name</label>
            <input autocomplete='given-name' type="text" class="form-control" id="billingFirstName"  [pattern]="nameValidatorPattern()" [(ngModel)]="selectedAccountCopy.billingFirstName"
              name="billingFirstName" #billingFirstName="ngModel"
              [required]="selectedAccountCopy?.status == 'active'" >

          </div>

          <div class="mb-3">
            <label [ngClass]="{'required':selectedAccountCopy?.status == 'active'}" class="form-label" for="billingLastName">Billing Last Name</label>
            <input autocomplete='family-name' type="text" class="form-control" id="billingLastName"  [pattern]="nameValidatorPattern()" [(ngModel)]="selectedAccountCopy.billingLastName"
              name="billingLastName" #billingLastName="ngModel" [required]="selectedAccountCopy?.status == 'active'">

          </div>

        </div>

        <div class="ui-g-2">

          <div class="mb-3">
            <label [ngClass]="{'required':selectedAccountCopy?.status == 'active'}" class="form-label" for="billingEmail">Billing Email Address</label>
            <input autocomplete='email' type="text" class="form-control" id="billingEmail"   [(ngModel)]="selectedAccountCopy.billingEmail"
              name="billingEmail" placeholder="email@domain.com" #billingEmail="ngModel" [required]="selectedAccountCopy?.status == 'active'">
          </div>

          <div class="mb-3">
            <label [ngClass]="{'required':selectedAccountCopy?.status == 'active'}" class="form-label" for="billingPhone">Billing Telephone Number</label>
            <input autocomplete='tel-national' type="text" class="form-control" id="billingPhone"  [(ngModel)]="selectedAccountCopy.billingPhone"
              name="billingPhone" #billingPhone="ngModel" [required]="selectedAccountCopy?.status == 'active'">
          </div>

        </div>

        <div class="ui-g-2">

          <div class="mb-3 required">
            <label [ngClass]="{'required':selectedAccountCopy?.status == 'active'}" class="form-label" for="billingCountry">Billing Country</label>
            <div class="input-group">
              <p-dropdown [(ngModel)]="selectedAccountCopy.billingCountry"  [filter]="true" [inputId]="'billingCountry'"
                placeholder="Select"  [required]="selectedAccountCopy?.status == 'active'" [style]="{'width': '100%'}" #billingCountry autocomplete='country-name'
                class="p-formcontrol" id="billingCountry" iuiCountry [region]="billingState" [name]="'billingCountry'"></p-dropdown>
            </div>
          </div>

          <div class="mb-3">
            <label [ngClass]="{'required':selectedAccountCopy?.status == 'active'}" class="form-label" for="billingAddress1">Billing Address 1</label>
            <input autocomplete='address-line1' type="text" class="form-control" id="billingAddress1"  [pattern]="nameValidatorPattern()" [(ngModel)]="selectedAccountCopy.billingAddress1"
              name="billingAddress1" placeholder="street address" #billingAddress1="ngModel" [required]="selectedAccountCopy?.status == 'active'">
          </div>

        </div>

        <div class="ui-g-2">

          <div class="mb-3">
            <label class="form-label" for="billingAddress2">Billing Address 2</label>
            <input autocomplete='address-line2' type="text" class="form-control" id="billingAddress2" [pattern]="nameValidatorPattern()" [(ngModel)]="selectedAccountCopy.billingAddress2"
              name="billingAddress2" placeholder="suite, floor, etc." #billingAddress2="ngModel">
          </div>

          <div class="mb-3">
            <label [ngClass]="{'required':selectedAccountCopy?.status == 'active'}" class="form-label" for="billingCity">Billing City</label>
            <input autocomplete='address-level2' type="text" class="form-control" id="billingCity"  [pattern]="nameValidatorPattern()" [(ngModel)]="selectedAccountCopy.billingCity"
              name="billingCity" #billingCity="ngModel" [required]="selectedAccountCopy?.status == 'active'">
          </div>

        </div>

        <div class="ui-g-2">

          <div class="mb-3 required">
            <label class="required form-label"[ngClass]="{'required':(selectedAccountCopy?.billingCountry == 'United States' || selectedAccountCopy?.billingCountry == 'Canada')}" for="billingState">Billing State/ Province</label>
            <div class="input-group">
              <p-dropdown [(ngModel)]="selectedAccountCopy.billingState" [disabled]="!selectedAccountCopy.billingCountry"  [filter]="true" [inputId]="'billingState'" [name]="'billingState'"
                placeholder="Select" [required]="selectedAccountCopy?.billingCountry == 'United States' || selectedAccountCopy?.billingCountry === 'Canada'"  [style]="{'width': '100%'}" #billingState autocomplete='address-level1'
                class="p-formcontrol" id="billingState" iuiRegion>
              </p-dropdown>
            </div>
          </div>

          <div class="mb-3">
            <label [ngClass]="{'required':(selectedAccountCopy?.billingCountry == 'United States' || selectedAccountCopy?.billingCountry == 'Canada')}"
            class="form-label" for="billingZipCode">Billing Postal/ ZIP Code</label>
            <input autocomplete='postal-code' type="text" class="form-control" id="billingZipCode" [required]="selectedAccountCopy?.billingCountry == 'United States' || selectedAccountCopy?.billingCountry === 'Canada'"
              [pattern]="zipCodeValidatorPattern(selectedAccountCopy?.billingCountry)" [(ngModel)]="selectedAccountCopy.billingZipCode" name="billingZipCode" #billingZipCode="ngModel">
          </div>

        </div>
      </div>

      
    </form>

  </div>

  <!-- change status ------------------------------------------------------ -->
  <div *ngIf="statusHandle?.showArea">

    <div class="ui-g result-bar">
      <div id="change-status">Change Status</div>
      <div class="ui-g-x">
        <button id="btn-changed-status-save" [disabled]="!isChangeStatusFormValid(statusHandle.currentStatus, statusHandle.changedStatus)" [class]="'w-auto btn ' + (!isChangeStatusFormValid(statusHandle.currentStatus, statusHandle.changedStatus) ? 'btn-disabled' : 'btn-default')"
          (click)="saveChangedStatus()">
          Save
        </button>
        <span style="margin-left: 2em;"></span>
        <button id="btn-changed-status-cancel" class="btn btn-secondary w-auto" (click)="cancelChangedStatus()">Cancel</button>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-1">
          <div class="mb-3">
            <label class="disabled form-label" for="accountId">Account ID</label>
            <input type="text" class="form-control" id="accountId" disabled [(ngModel)]="selectedAccountCopy.accountId" name="accountId"
              placeholder="Account ID" #accountId="ngModel">
          </div>
        </div>
        <div class="ui-g-2">
          <div class="mb-3">
            <label class="disabled form-label" for="companyName">Company Name</label>
            <input type="text" class="form-control" id="companyName" disabled [(ngModel)]="selectedAccountCopy.companyName"
              name="companyName" placeholder="company Name" #companyName="ngModel">
          </div>
        </div>
        
        <div class="ui-g-3">
          <div>
            <div class="mb-2">
              <label class="required form-label" for="status">Status</label>
              <select class="form-control" id="status" [ngModel]="statusHandle.changedStatus" (ngModelChange)="changeStatus($event)" [disabled]="selectedAccountCopy?.status=='inactive'">
                  <option disabled value="pending">Pending</option>
                  <option [disabled]="statusHandle.currentStatus === 'rejected' || statusHandle.currentStatus === 'inactive' || statusHandle.currentStatus === 'approved' || statusHandle.currentStatus === 'active'" value="rejected">Rejected</option>
                  <option [disabled]="statusHandle.currentStatus === 'approved' || statusHandle.currentStatus === 'inactive' || statusHandle.currentStatus === 'active'" value="approved">Approved</option>
                  <option disabled value="active">Active</option>
                  <option [disabled]="statusHandle.currentStatus === 'inactive'" value="inactive">Inactive</option>
              </select>
            </div>
          </div>
        </div>

        <div class="ui-g-5">
          <div class="mb-3">
            <label class="form-label" for="reason"  [ngClass]="{'required':(statusHandle.changedStatus == 'inactive' || statusHandle.changedStatus == 'rejected')}">Reason</label>
            <input type="text" class="form-control" id="reason" [(ngModel)]="selectedAccountCopy.reason" name="reason" placeholder="enter reason here (max. 250 characters)"
              #reason="ngModel">
          </div>
        </div>

      </div>

      <div class="ui-g-12">
          <div class="ui-g-2">
            <div class="mb-3">
              <label class="form-label" for="inactiveNotificationDate" [ngClass]="{'required':statusHandle.changedStatus == 'inactive'}">Inactive Notification Date</label>
              <p-inputMask inputId="inactiveNotificationDate" [disabled]="statusHandle.changedStatus != 'inactive'" [(ngModel)]="selectedAccountCopy.inactiveNotificationDate" name="inactiveNotificationDate"
                placeholder="YYYY-MM-DD"  mask="9999-99-99" characterPattern="[0-9]" #inactiveNotificationDate="ngModel"></p-inputMask>
            </div>
          </div>
          <div class="ui-g-2">
              <div class="mb-3">
                <label class="form-label" for="inactiveEffectiveDate" [ngClass]="{'required':statusHandle.changedStatus == 'inactive'}">Inactive Effective Date</label>
                <p-inputMask inputId="inactiveEffectiveDate" [disabled]="statusHandle.changedStatus != 'inactive'" [(ngModel)]="selectedAccountCopy.inactiveEffectiveDate" name="inactiveEffectiveDate"
                  placeholder="YYYY-MM-DD"  mask="9999-99-99" characterPattern="[0-9]" #inactiveEffectiveDate="ngModel"> </p-inputMask>
              </div>
            </div>
      </div>
    </div>
  </div>

  <!-- display found Account data ----------------------------------------- -->
  <div id="can-you-see-me-now"></div>
  <div class="row" *ngIf="accounts?.length > 0">

    <!-- action section --------------------------------------------------- -->
    <div class="col ui-g result-bar sticky-result">
      <div class="ui-g-4">
        <span style="margin-top: 8px; font-size: 14px;">
            (Displaying
            {{ptable.rows > ptable.totalRecords ? ptable.totalRecords : ptable.rows + first > ptable.totalRecords ? ptable.totalRecords - first : ptable.rows}}
            of {{ptable.totalRecords}})
        </span>
      </div>
      <div class="ui-g-8">
        <button id="btn-edit-account" style="margin-left: 2em;" [disabled]="!(editHandle?.canEditAccount)" [class]="'btn pull-right w-auto ' + (editHandle?.canEditAccount ? 'btn-default' : 'btn-disabled')" (click)="showEditAccountArea()">Edit Account</button>
        <button id="btn-change-status" style="margin-left: 2em;" [disabled]="!(statusHandle?.canChangeStatus)" [class]="'btn pull-right w-auto ' + (statusHandle?.canChangeStatus ? 'btn-inverse' : 'btn-disabled')" (click)="showChangeStatusArea()">Change Status</button>
        <button id="btn-change-status" style="margin-left: 2em;" [disabled]="!(editHandle?.canDeleteAccount)" [class]="'btn pull-right w-auto ' + (editHandle?.canDeleteAccount  ? 'btn-inverse' : 'btn-disabled')" (click)="showDeleteDialog()">Delete Account</button>
        <button id="btn-add-users" disabled style="margin-left: 2em;" class="btn btn-disabled pull-right w-auto" (click)="addUsers()">Add Users</button>
       
      </div>
    </div>
    <div style="font-size: 12px">
      <p-table
        (onFilter)="onFilter($event)"
        (onPage)="onPage($event)"
        (onRowSelect)="onRowSelect($event)"
        (onRowUnselect)="onRowUnselect($event)"
        (onSort)="onSort($event)"
        [(selection)]="selectedAccount"
        [columns]="cols"
        [pageLinks]="5"
        [paginator]="true"
        [rows]="100"
        [rowsPerPageOptions]="[100,500,1000,2000]"
        [styleClass]="'btable'"
        [value]="accounts"
        #ptable
        columnResizeMode="none"
        dataKey="accountId"
        id="account-table"
        selectionMode="single"
        sortField="{{sortFieldTable.accountId}}"
        [sortOrder]="sortFieldTable.order"
       
        >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th [style.width.%]="col.width" *ngFor="let col of columns" [pSortableColumn]="col.field" class="labels">
              <span class="account-tbl-header-size">{{col.header}}</span>
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
          </tr>
          <tr>
            <th *ngFor="let col of cols" [ngSwitch]="col.field" class="filters">

              <!-- filter: 'startsWith' -->
              <!--input [(ngModel)]="filter[col.field]" *ngSwitchDefault class="form-control filter-size" type="text" (input)="ptable.filter($event.target.value, col.field, col.filterMatchMode)"-->

              <input [(ngModel)]="filter[col.field]" *ngSwitchCase="'accountId'" class="form-control filter-size" type="text" (input)="ptable.filter($event.target.value, col.field, col.filterMatchMode)">
              <input [(ngModel)]="filter[col.field]" *ngSwitchCase="'companyName'" class="form-control filter-size" type="text" (input)="ptable.filter($event.target.value, col.field, col.filterMatchMode)">
              <input [(ngModel)]="filter[col.field]" *ngSwitchCase="'firstName'" class="form-control filter-size" type="text" (input)="ptable.filter($event.target.value, col.field, col.filterMatchMode)">
              <input [(ngModel)]="filter[col.field]" *ngSwitchCase="'lastName'" class="form-control filter-size" type="text" (input)="ptable.filter($event.target.value, col.field, col.filterMatchMode)">

              <!-- filter: remove updateDateTime filter -->
              <span disabled *ngSwitchCase="'createDateTime'"></span>

              <!-- filter: 'contains' -->
              <input [(ngModel)]="filter.email" *ngSwitchCase="'email'" class="form-control filter-size" type="text" (input)="ptable.filter($event.target.value, col.field, 'contains')">

              <!-- filter: multi-select -->
              <p-multiSelect [(ngModel)]="filter.accountType" *ngSwitchCase="'accountType'" class="p-formcontrol" [options]="accountTypes" placeholder="All"
                (onChange)="ptable.filter($event.value, col.field, 'in')"></p-multiSelect>

                <p-multiSelect [(ngModel)]="filter.contractType" *ngSwitchCase="'contractType'" class="p-formcontrol" [options]="contractTypes" placeholder="All"
                (onChange)="ptable.filter($event.value, col.field, 'in')"></p-multiSelect>

                <p-multiSelect [(ngModel)]="filter.serviceAgreementAccepted" *ngSwitchCase="'serviceAgreementAccepted'" class="p-formcontrol" [options]="agreementTypes" placeholder="All"
                (onChange)="ptable.filter($event.value, col.field, 'in')"></p-multiSelect>

              <p-multiSelect [(ngModel)]="filter.status" *ngSwitchCase="'status'" class="p-formcontrol" [options]="accountStatuses" placeholder="All" displaySelectedLabel=true
                (onChange)="ptable.filter($event.value, col.field, 'in')" ></p-multiSelect>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr [pSelectableRow]="rowData">
            <td *ngFor="let col of columns" [ngSwitch]="col.field">
              <span *ngSwitchDefault>{{rowData[col.field]}}</span>
              <span *ngSwitchCase="'accountId'"><a [routerLink]="['/usage', rowData[col.field]]">{{rowData[col.field]}}</a></span>
              <span *ngSwitchCase="'createDateTime'">{{rowData[col.field] | date:'yyyy-MM-dd h:mm a'}}</span>
              <span *ngSwitchCase="'serviceAgreementAccepted'">{{rowData[col.field] | agreement}}</span>
              <span *ngSwitchCase="'firstName'">{{rowData[col.field] | capitalize}}</span>
              <span *ngSwitchCase="'lastName'">{{rowData[col.field] | capitalize}}</span>
              <span *ngSwitchCase="'phone'">{{rowData[col.field] | adddashes}}</span>
              <div *ngSwitchCase="'email'" tooltipStyleClass="sd" [pTooltip]="rowData[col.field]?.length > truncateThreshold ? rowData[col.field]?.toString() : ''" tooltipPosition="top" >{{rowData[col.field] | truncate: truncateThreshold}}</div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-dialog 
#reportDialog
[(visible)]="display"
header="Delete Account"
class="report-modal"
[baseZIndex]="1000" 
[modal]="true"
[style]="{ width: '50vw' }"
[contentStyle]="{'max-height':'80vh'}"
(onHide)="dialogClosed()"
[closable]="false" >

  <div class="row">
    <div>Confirm that this account is a duplicate, added in error, or an invalid registration. Clicking the OK button will hide the registration and will no longer be visible on the Accounts list. A registration can be restored by contacting the DEV team.</div>
    
      <div class="ui-g-12 button-bottom" style="display: flex; justify-content: center; gap: 1rem; margin-top: 2rem;">
        <button id="cancel-queue-btn-tn" type="button" class="btn btn-secondary cancel-queue-btn" (click)="ok()">Ok</button>
        <button id="queue-report-btn-tn" type="button" class="btn btn-secondary cancel-queue-btn" (click)="cancel()">Cancel</button>
      
    </div>
 
</div>
 




</p-dialog>

